import { ContentType, HttpClient, RequestParams } from '../http-client';

export class CompanyPayroll<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getCompanyPayrollSetting = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/settings`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyPayrollSetting = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/settings`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCrewPayrollProfile = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/profile/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCrewPayrollProfile = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/profile/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyPayrollList = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/periods`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCrewPayrollBankAccounts = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/profile/${id}/banks`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyPayrollDetail = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/periods/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyPayrollEntryDetail = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/periods/entries/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyPayrollConditions = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/conditions`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyPayrollConditions = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/conditions`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCrewPayrollBankAccounts = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/profile/${id}/banks`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  

  patchCompanyPayrollEntry = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/periods/entries/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCrewPayrollBankAccounts = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/payrolls/profile/banks/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
